import { finalize } from 'rxjs/operators';

export function Loading(target: object, name: string | symbol, descriptor: PropertyDescriptor): void {
  const original = descriptor.value;

  descriptor.value = function(...args: unknown[]): unknown {
    if (this.loading) {
      this.startLoading();
      return original.call(this, ...args).pipe(finalize(() => this.completeLoading()));
    }
    return original.call(this, ...args);
  };
}
